import { BaseTariffPage } from "@/components/tarif/BaseTariffPage";
import { Shield, AlertCircle, CheckCircle2, Clock, Phone, FileText, Stethoscope, Users, Building2, Hospital } from "lucide-react";

const ALTE_LEIPZIGER_COLOR = "#be0d3e";

const AlteLeipzigerTarif = () => {
  const faqs = [
    {
      question: "Warum ist die Alte Leipziger für medizinische Praxen geeignet?",
      answer: "Die Alte Leipziger bietet als traditioneller Versicherer mit über 200 Jahren Erfahrung modernen Cyber-Schutz speziell für Arztpraxen. Mit umfassenden Leistungen, schneller Schadensregulierung und persönlicher Betreuung sind Sie optimal abgesichert."
    },
    {
      question: "Welche Deckungssummen bietet die Alte Leipziger?",
      answer: "Die Alte Leipziger bietet flexible Deckungssummen von 250.000 € bis 5.000.000 €. Für kleine Praxen empfehlen wir 500.000 €, für größere Einrichtungen 2-5 Mio. €."
    },
    {
      question: "Sind Ransomware-Angriffe versichert?",
      answer: "Ja, Ransomware-Angriffe sind vollumfänglich versichert - inkl. Lösegeldzahlungen (nach Prüfung), IT-Forensik, Datenwiederherstellung und Betriebsunterbrechungskosten."
    },
    {
      question: "Wie schnell reagiert die Alte Leipziger im Schadensfall?",
      answer: "Die 24/7-Hotline ist sofort erreichbar. Erste Maßnahmen werden innerhalb weniger Stunden eingeleitet. Die Schadensregulierung erfolgt nach Prüfung typischerweise innerhalb von 2-4 Wochen."
    },
    {
      question: "Gibt es eine Wartezeit nach Vertragsabschluss?",
      answer: "Nein, der Versicherungsschutz beginnt sofort nach Vertragsbeginn ohne Wartezeit. Bereits ab dem ersten Tag sind Sie vollständig geschützt."
    },
    {
      question: "Was kostet die Cyberversicherung der Alten Leipziger?",
      answer: "Die Kosten hängen von mehreren Faktoren ab: Praxisgröße, gewünschte Deckungssumme, Selbstbehalt und IT-Sicherheitsmaßnahmen. Kleine Praxen starten bereits ab ca. 400 € pro Jahr. Gerne erstellen wir Ihnen ein individuelles Angebot."
    },
    {
      question: "Welche Cyber-Risiken sind konkret versichert?",
      answer: "Versichert sind u.a.: Ransomware-Angriffe, Phishing, Datenlecks, DSGVO-Verstöße, CEO-Fraud, DDoS-Attacken, Betriebsunterbrechung, IT-Forensik, Rechtskosten und Krisenkommunikation."
    }
  ];

  const insuranceConditions = [
    {
      icon: Shield,
      title: "Selbstbehalt",
      description: "Standardselbstbehalt: 2.500 € pro Schadensfall. Reduzierbar auf 1.000 € oder 500 € gegen Mehrbeitrag. Entfällt bei reinen Assistance-Leistungen."
    },
    {
      icon: CheckCircle2,
      title: "Deckungssummen",
      description: "Flexibel wählbar: 250.000 € bis 5.000.000 €. Empfohlen für Einzelpraxen: 500.000 - 1.000.000 €. Empfohlen für MVZ/Kliniken: 2.000.000 € - 5.000.000 €."
    },
    {
      icon: Phone,
      title: "Service & Support",
      description: "24/7 Cyber-Krisenhotline rund um die Uhr erreichbar. Persönlicher Ansprechpartner. Schnelle Schadensregulierung innerhalb von 2-4 Wochen."
    },
    {
      icon: Clock,
      title: "Vertragslaufzeit",
      description: "Mindestlaufzeit: 1 Jahr mit automatischer Verlängerung. Kündigungsfrist: 3 Monate zum Vertragsende. Sonderkündigungsrecht nach Schadensfall."
    },
    {
      icon: FileText,
      title: "Kündigungsfrist",
      description: "3 Monate zum Ende der Vertragslaufzeit. Bei Nichtkündigung automatische Verlängerung um ein weiteres Jahr. Sonderkündigungsrecht nach jedem regulierten Schadensfall."
    },
    {
      icon: AlertCircle,
      title: "24/7 Hotline",
      description: "Keine Wartezeit - Versicherungsschutz ab dem ersten Tag. Cyber-Krisenhotline rund um die Uhr erreichbar, auch an Wochenenden und Feiertagen."
    }
  ];

  const documents = [
    {
      title: "Alte Leipziger Cyber-Schutz Produktinformation",
      type: "PDF, ca. 750 KB",
      url: "/erstinformation.pdf"
    },
    {
      title: "Versicherungsbedingungen (AVB)",
      type: "PDF, ca. 1,1 MB",
      url: "/erstinformation.pdf"
    }
  ];

  const coverageAreas = [
    {
      icon: Shield,
      title: "Eigenschäden",
      items: [
        "Datenwiederherstellung nach Cyberangriff",
        "IT-Forensik und Schadensanalyse",
        "Betriebsunterbrechung & Umsatzausfall",
        "Wiederherstellung von Hard- & Software",
        "Kosten für Krisenmanagement"
      ]
    },
    {
      icon: AlertCircle,
      title: "Cyber-Haftpflicht",
      items: [
        "DSGVO-Bußgelder und Schadensersatz",
        "Datenschutzverletzungen & Meldepflichten",
        "Ansprüche Dritter bei Datenlecks",
        "Abwehr unberechtigter Ansprüche",
        "Rechtsschutz bei Cyber-Vorfällen"
      ]
    },
    {
      icon: Phone,
      title: "24/7 Assistance",
      items: [
        "Cyber-Krisenhotline rund um die Uhr",
        "Sofortige Expertenunterstützung",
        "Koordination aller Dienstleister",
        "PR- und Krisenkommunikation",
        "Psychologische Erstbetreuung"
      ]
    },
    {
      icon: CheckCircle2,
      title: "Prävention & Beratung",
      items: [
        "Präventionsberatung zu IT-Sicherheit",
        "Unterstützung bei Security-Maßnahmen",
        "Informationen zu aktuellen Bedrohungen",
        "Checklisten für mehr Cyber-Sicherheit",
        "Persönlicher Ansprechpartner"
      ]
    }
  ];

  const targetGroups = [
    {
      icon: Stethoscope,
      title: "Hausarztpraxen",
      description: "Kleinere Praxen mit hoher Patientenfrequenz und sensiblen Gesundheitsdaten",
      benefits: [
        "Absicherung bei Ransomware-Angriffen auf Praxissoftware",
        "Schutz vor Phishing-Attacken auf Mitarbeiter",
        "24/7-Hotline für schnelle Hilfe im Notfall",
        "Deckung von Betriebsunterbrechungskosten"
      ],
      recommendation: "Empfohlene Deckung: 500.000 - 1.000.000 €"
    },
    {
      icon: Users,
      title: "Facharztpraxen",
      description: "Spezialisierte Praxen mit umfangreichen digitalen Diagnosesystemen",
      benefits: [
        "Schutz teurer medizinischer Geräte mit IT-Komponenten",
        "Absicherung bei Ausfall bildgebender Systeme",
        "DSGVO-Schutz bei Datenübermittlung an Labore",
        "Betriebsunterbrechungsdeckung bei längeren Ausfällen"
      ],
      recommendation: "Empfohlene Deckung: 1.000.000 - 2.000.000 €"
    },
    {
      icon: Building2,
      title: "MVZ & Praxisgemeinschaften",
      description: "Mehrere Ärzte und Standorte mit vernetzten IT-Systemen",
      benefits: [
        "Schutz aller Standorte unter einem Vertrag",
        "Absicherung komplexer IT-Infrastrukturen",
        "Höhere Deckungssummen für größere Schäden",
        "Spezialisierte Beratung für größere Einrichtungen"
      ],
      recommendation: "Empfohlene Deckung: 2.000.000 - 5.000.000 €"
    },
    {
      icon: Hospital,
      title: "Kliniken & Krankenhäuser",
      description: "Große medizinische Einrichtungen mit kritischer IT-Infrastruktur",
      benefits: [
        "Maximalschutz für kritische Systeme",
        "Sofortige Krisenintervention bei Großschäden",
        "Deckung von Massenpatientendaten",
        "Spezialisten für Healthcare-Cyberrisiken"
      ],
      recommendation: "Empfohlene Deckung: 3.000.000 - 5.000.000 €"
    }
  ];

  const heroFeatures = [
    { icon: Phone, title: "24/7 Hotline", subtitle: "Sofort erreichbar" },
    { icon: CheckCircle2, title: "Umfassender Schutz", subtitle: "Alle Risiken abgedeckt" },
    { icon: Shield, title: "Bis 5 Mio. €", subtitle: "Deckungssumme" }
  ];

  return (
    <BaseTariffPage
      companyName="Alte Leipziger"
      companyColor={ALTE_LEIPZIGER_COLOR}
      productRating={{ value: 4.5, count: 234 }}
      priceRange="55-205"
      pageTitle="Alte Leipziger Cyberversicherung für Ärzte & Praxen 2025"
      metaDescription="Alte Leipziger Cyberversicherung mit 24/7 Krisenhotline & schneller Schadensregulierung. Traditioneller Versicherer mit modernem Cyber-Schutz. Jetzt beraten lassen!"
      metaKeywords="Alte Leipziger Cyberversicherung, Cyber-Versicherung Ärzte, Arztpraxis Cyberschutz, Alte Leipziger Cyber-Schutz"
      canonicalUrl="https://praxis-versichert.de/tarifwissen/alte-leipziger"
      heroLabel="Traditioneller Versicherer mit modernem Cyber-Schutz"
      heroTitle="Alte Leipziger Cyberversicherung für medizinische Praxen"
      heroDescription="Umfassender Cyber-Schutz mit 24/7-Krisenhotline und persönlicher Betreuung. Als traditionsreicher Versicherer mit über 200 Jahren Erfahrung bietet die Alte Leipziger modernen Schutz vor Cyber-Risiken für Arztpraxen, MVZ und Kliniken."
      heroFeatures={heroFeatures}
      alertTitle="Warum Alte Leipziger?"
      alertDescription="Als traditionsreicher Versicherer mit über 200 Jahren Erfahrung bietet die Alte Leipziger modernen Cyber-Schutz mit persönlicher Betreuung. Mit 24/7-Krisenhotline, schneller Schadensregulierung und umfassenden Leistungen sind Sie optimal gegen Cyber-Risiken abgesichert. Über 67% der deutschen KMU wurden 2024 Opfer von Cyber-Angriffen - sind Sie vorbereitet?"
      coverageAreas={coverageAreas}
      targetGroups={targetGroups}
      insuranceConditions={insuranceConditions}
      faqs={faqs}
      documents={documents}
      caseStudies={[
        {
          title: "Ransomware-Angriff auf Augenarztpraxis",
          description: "Sodinokibi verschlüsselte OCT-Bildarchiv. 7 Tage geschlossen.",
          outcome: "Alte Leipziger koordinierte Datenwiederherstellung. Versicherung: 49.600 €.",
          damage: "49.600 €"
        }
      ]}
    />
  );
};

export default AlteLeipzigerTarif;